/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_ValueInputs */

const en_entity_value = /** @type {(inputs: Entity_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Value`)
};

const de_entity_value = /** @type {(inputs: Entity_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wert`)
};

/**
* | output |
* | --- |
* | "Value" |
*
* @param {Entity_ValueInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const entity_value = /** @type {((inputs?: Entity_ValueInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_ValueInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_value(inputs)
	return de_entity_value(inputs)
});